// extracted by mini-css-extract-plugin
module.exports = {"container":"policy_container__uWrx_"};